import {
    each,
    object2array,
} from './utils.js';

const DEFAULT_DATA = {
    dishes: {
        isActive: false,
    },
    categories: {
        isActive: false,
        timespans: function(timespans, category, categories) {
            return timespans.map(timespan => {
                return {
                    begin: new Date(timespan.begin),
                    end: new Date(timespan.end),
                };
            })
        }
    },
    diets: {
        isActive: false
    },
    intolerances: {
        isActive: false
    },
    stations: {}
};

const RELATIONS_MAP = {
    dishes: {
        "diet": "diets",
        "intolerances": "intolerances",
    },
    diets: {
        "inactiveIntolerances": "intolerances",
    },
    categories: {
        "dishes": "dishes",
    }
};


export default function(collections) {

    const parsed = collections;

    // fill default data into items of each data category
    each(DEFAULT_DATA, (key, values_) => {

        parsed[key] = each(collections[key], (id, item) => {

            const values = Object.assign({}, values_);

            each(values, (k, v) => {
                if (typeof v === 'function') {

                    values[k] = v(item[k], item, parsed[key]);
                }
            });

            const rtn = Object.assign({}, item, values);

            return rtn;
        });
    });

    // fill default data into items of each data category
    each(RELATIONS_MAP, (type, map) => {
        parsed[type] = each(parsed[type], (id, item) => {
            each(map, (key, refName) => {

                const plain = item[key];
                const target = parsed[refName];
                let result;

                if (typeof plain === 'number') {
                    result = target[`id-${plain}`];
                } else if (plain !== null && Array.isArray(plain)) {
                    result = plain.map(id =>  {
                        return target[`id-${id}`];
                    });
                }
                item[key] = result;
            });

            return item;
        });
    });

    function getStationByDish(dish, stations) {
        let foundStation = null;
        each(stations, (id, station) => {

            if (!foundStation && station.dishes.indexOf(dish.id) !== -1) {
                foundStation = station;
            }
        });

        return foundStation;
    }

    const ranges = {};

    const sliderNames = [
        'breadUnits',
        'kcals',
    ];

    sliderNames.forEach(propName => {
        ranges[propName] = {
            min: 1,
            max: 10,
        };
    });

    each(parsed.dishes, (id, dish) => {

        dish.station = getStationByDish(dish, parsed.stations);

        sliderNames.forEach(propName => {
            const prop = dish[propName];
            const propRange = ranges[propName];

            const min = propRange.min || 1;
            const max = propRange.max || 1;
            let resultMin = min;
            let resultMax = prop > max
                ? prop
                : max;

            if (min > 1 && prop < min) {
                resultMin = prop;
            }

            propRange.min = resultMin;
            propRange.max = resultMax;
        });
    });

    parsed.ranges = ranges;

    [
        'diets',
        'categories',
        'dishes',
        'intolerances',
        'diets',
        'stations',
    ].forEach(name => {
        parsed[name] = object2array(parsed[name]);
    });

    parsed.categories.forEach(category => {
        category.filteredDishes = [];
        category.currentDishes = [];
    });

    parsed.diets.forEach((diet, index) => {
        diet.allowed = parsed.diets.slice(index);
    });

    collections.additionalFilters.forEach(additionalFilter => {

        collections.diets.push(Object.assign({}, collections.diets[0], {
            name: additionalFilter.name,
            title: additionalFilter.title,
            id: null,
        }));
    });

    return parsed;
}
